module.exports = __webpack_public_path__ + "media/images/impressions-6dfb2fc77e552cad75856282b3e307fd.jpg";